import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  name: string;
};

export const Page = (props: Props) => {
  return <div className={`page ${props.name}`}>{props.children}</div>;
};
